export default "__VITE_ASSET__4ee84a82__"